/* ============================================================
   OATES COLLECTION ↔ BOT BRIDGE  (v32)
   Listens for 'oates:bot-match' events fired by the Hey Oates widget.
   When the bot matches products that exist in the current grid:
     1. Adds .card--bot-match class to those cards (maroon glow)
     2. Reorders DOM so matched cards float to the top
     3. Auto-clears after 60s OR when user submits a new query / scrolls past

   Only runs on collection pages.
   ============================================================ */
(function () {
  'use strict';

  const HIGHLIGHT_DURATION_MS = 60000; // auto-clear after 60s
  let activeMatchClearTimer = null;

  function getGrid() {
    return document.querySelector('.collection-grid[data-collection-handle]');
  }

  function clearAllMatches() {
    const grid = getGrid();
    if (!grid) return;
    const matched = grid.querySelectorAll('.card--bot-match');
    matched.forEach(function (card) {
      card.classList.remove('card--bot-match');
      card.style.order = ''; // restore default DOM order
    });
    const banner = document.querySelector('.bot-match-banner');
    if (banner) banner.remove();
    if (activeMatchClearTimer) {
      clearTimeout(activeMatchClearTimer);
      activeMatchClearTimer = null;
    }
  }

  // v33.1: normalize like the widget so encoded ® and case differences match
  function normalizeHandle(h) {
    if (!h) return '';
    try { h = decodeURIComponent(h); } catch (e) {}
    return h.replace(/[\u00ae\u2122\u00a9]/g, '').replace(/--+/g, '-').replace(/^-|-$/g, '').toLowerCase();
  }

  function highlightMatches(handles, query) {
    const grid = getGrid();
    if (!grid || !handles || !handles.length) return;

    // Clear previous match state before applying new one
    clearAllMatches();

    // Build a lookup of normalized grid handles → card element so we tolerate
    // any encoding/case differences between widget-sent handles and DOM attrs.
    const cardByHandle = {};
    grid.querySelectorAll('[data-product-handle]').forEach(function (el) {
      const norm = normalizeHandle(el.getAttribute('data-product-handle'));
      if (norm) cardByHandle[norm] = el;
    });

    let matchedCount = 0;
    handles.forEach(function (handle, idx) {
      const card = cardByHandle[normalizeHandle(handle)];
      if (card) {
        card.classList.add('card--bot-match');
        card.style.order = String(-1000 + idx);
        matchedCount++;
      } else {
        console.warn('[collection-bridge] no card found for handle:', handle, '(normalized:', normalizeHandle(handle) + ')');
      }
    });

    if (matchedCount === 0) return;

    // Insert a "Showing matches for..." banner above the grid
    insertBanner(matchedCount, query);

    // Scroll the grid into view so the user can see what happened
    grid.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // Auto-clear after timeout
    activeMatchClearTimer = setTimeout(clearAllMatches, HIGHLIGHT_DURATION_MS);
  }

  function insertBanner(count, query) {
    const grid = getGrid();
    if (!grid) return;
    const banner = document.createElement('div');
    banner.className = 'bot-match-banner';
    banner.innerHTML =
      '<span class="bot-match-banner__icon" aria-hidden="true">✨</span>' +
      '<span class="bot-match-banner__text">' +
        '<strong>' + count + ' product' + (count > 1 ? 's' : '') + '</strong> matched ' +
        (query ? 'for "<em>' + escapeHtml(query) + '</em>"' : 'your question') +
      '</span>' +
      '<button type="button" class="bot-match-banner__clear" aria-label="Clear filter">' +
        'Show all' +
      '</button>';
    grid.parentNode.insertBefore(banner, grid);

    banner.querySelector('.bot-match-banner__clear').addEventListener('click', clearAllMatches);
  }

  // Lightweight CSS.escape polyfill for older browsers
  function cssEscape(s) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(s);
    return String(s).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  // ---- Wire up event listener ----------------------------------
  function init() {
    // Only run on collection pages (grid present)
    if (!getGrid()) return;

    document.addEventListener('oates:bot-match', function (e) {
      const handles = (e.detail && e.detail.handles) || [];
      const query   = (e.detail && e.detail.query) || '';
      highlightMatches(handles, query);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for debugging
  window.OatesCollectionBridge = {
    highlightMatches: highlightMatches,
    clearAllMatches: clearAllMatches
  };
})();
